import './OverrideBanner.css';

function fmtVal(v) {
  if (typeof v === 'number') {
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return v === '' || v == null ? '—' : String(v);
}

function fmtWhen(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function editorName(o) {
  const name = [o.edited_by_first, o.edited_by_last].filter(Boolean).join(' ').trim();
  return name || 'Unknown';
}

/**
 * Renders the append-only override trail for a finalized remit or a self-pay
 * payment. Each entry shows who/when, the field-level was→now diff, and the
 * reason. `compact` drops the section wrapper for inline (table-row) use.
 */
export default function OverrideBanner({ overrides = [], compact = false }) {
  if (!overrides.length) return null;

  return (
    <div className={`ovb ${compact ? 'ovb-compact' : ''}`}>
      <div className="ovb-head">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span>{overrides.length === 1 ? 'This record was overridden' : `This record was overridden ${overrides.length} times`}</span>
      </div>

      {overrides.map((o, i) => (
        <div key={o.override_id ?? i} className="ovb-entry">
          <div className="ovb-meta">
            Overridden by <strong>{editorName(o)}</strong> · {fmtWhen(o.created_at)}
          </div>
          <ul className="ovb-changes">
            {(o.changes || []).map((c, j) => (
              <li key={j}>
                <span className="ovb-field">{c.label}</span>
                <span className="ovb-from">{fmtVal(c.from)}</span>
                <span className="ovb-arrow">→</span>
                <span className="ovb-to">{fmtVal(c.to)}</span>
              </li>
            ))}
          </ul>
          {o.reason && <div className="ovb-reason"><span>Reason:</span> {o.reason}</div>}
        </div>
      ))}
    </div>
  );
}
